export class SaleFormat {
  constructor(item = {}) {
    this.saleFormatGuid = item.saleFormatGuid || '-1';
    this.productGuid = item.productGuid || '-1';
  }
}
